import { T_IntegrationType } from "types";
import { E_Route } from "utils/constants";
import { DONE_MESSAGE } from "../layouts";

export const authFlowInterface = (
  url: string,
  e: React.MouseEvent<HTMLDivElement, MouseEvent>,
  onCompleted: () => void,
  showInfo?: T_IntegrationType,
) => {
  // We want to try to position the popup window in such a way that
  // it appears over the button that opened it.
  const buttonPosition = e.currentTarget?.getBoundingClientRect();
  const popupHeight = 690;
  const popupWidth = 420;
  const windowPos = [window.screenX, window.screenY];
  const buttonCenter = [
    buttonPosition ? buttonPosition.left + buttonPosition?.width / 2 : 40,
    buttonPosition ? buttonPosition.top + buttonPosition?.height || 40 / 2 : 40,
  ];
  const popupPos = [
    buttonCenter[0] - popupWidth / 2,
    buttonCenter[1] - popupHeight / 2,
  ];
  const adjustedPopupPos = [
    popupPos[0] + windowPos[0],
    popupPos[1] + windowPos[1],
  ];

  // escape & and ? in the url
  const encodedUrl = encodeURIComponent(url);

  const target = window.open(
    showInfo
      ? `${E_Route.Warning}?integration=${showInfo}&url=${encodedUrl}`
      : url,
    "googleConnect",
    `height=${popupHeight},width=${popupWidth},left=${adjustedPopupPos[0]},top=${adjustedPopupPos[1]},popup=yes`,
  );

  // We may or may not be able to open the oauth flow in a popup
  // window. If we _were_ able to, then wait for a postMessage
  // indicating that oauth is complete, then close the window. In the
  // case where we weren't, just redirect to the oauth url.
  if (target && typeof window !== "undefined") {
    window.addEventListener("message", async (ev) => {
      if (ev.data === DONE_MESSAGE) {
        onCompleted();
        // await refetchSlackInstall();
        target.close();
      }
    });
    window.addEventListener("load", async () => {
      onCompleted();
      // await refetchSlackInstall();
      target.close();
    });
  } else {
    // eslint-disable-next-line no-restricted-globals
    let a = document.createElement("a");
    a.target = "_blank";
    a.href = url;
    a.click();
  }
};
